import type { FC, MouseEvent } from "react";
import { useState } from "react";

import { InputField } from "@/ui/components/form/Input/InputField";
import { IconButton } from "@/ui/components/primitives/IconButton";
import { FieldWrapper } from "../shared";
import type { TPasswordProps } from "./Password.config";

export const Password: FC<TPasswordProps> = (
  {
    label,
    disabled,
    value,
    className,
    error,
    ...props
  },
) => {
  const [ isVisible, setIsVisible ] = useState(false);

  const handleToggleVisibility = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsVisible((currentIsVisible) => !currentIsVisible);
  };

  return (
    <FieldWrapper
      componentName="Password"
      className={className}
      disabled={disabled}
      error={error}
      label={label}
    >
      <div className="relative">
        <InputField
          {...props}
          type={isVisible ? "text" : "password"}
          value={value}
          disabled={disabled}
          error={error}
          className="pr-12 text-clip focus:ring-focus-secondary"
        />
        <IconButton
          aria-label={isVisible ? "Hide password" : "Show password"}
          icon={isVisible ? "eyeOff" : "eye"}
          size="sm"
          variant="tertiary"
          disabled={disabled}
          className="absolute right-1 top-1/2 -translate-y-1/2 border-transparent bg-transparent active:shadow-none"
          onClick={handleToggleVisibility}
        />
      </div>
    </FieldWrapper>
  );
};

Password.displayName = "Password";
